import { createContext, useState, useEffect, useContext } from 'react';
import api from '../api/api';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    api.get(`${process.env.REACT_APP_API_URL}/accounts/api/user/`)
      .then((res) => setUserInfo(res.data))
      .catch((err) => console.error('ユーザー情報取得エラー:', err));
  }, []);

  return (
    <UserContext.Provider value={userInfo}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
